import React, { type FC } from 'react';
import { FormattedMessage } from 'react-intl-next';

import { LinkMenuItem } from '@atlaskit/navigation-system/side-nav-items/link-menu-item';

import { HashIconComponent } from '../GlobalNavigationIcons';
import { i18n } from '../globalNavigationTranslations';

import { useGlobalItemVisibility } from './useGlobalItemVisibility';
import type { GlobalItemProps } from './globalItemProps';

export const TopicsItem: FC<GlobalItemProps> = ({ isHidden, peekingId, setPeekingId }) => {
	const isSelected = false; //toDo: this will be the all Spaces URL once flyouts support selected state
	const shouldHide = useGlobalItemVisibility(
		'topics',
		isSelected,
		isHidden,
		peekingId,
		setPeekingId,
	);

	if (shouldHide) {
		return null;
	}

	return (
		<LinkMenuItem href="#" elemBefore={HashIconComponent}>
			<FormattedMessage {...i18n.topics} />
		</LinkMenuItem>
	);
};
